export default {
  home: {
    hero: {
      badge: 'Centre de ressources indépendant',
      title: 'USFans Spreadsheet — Le centre de ressources complet',
      subtitle: 'Trouvez les ressources du USFans spreadsheet, les avis, les informations de livraison, les coupons, les comparaisons et les guides pratiques, le tout organisé au même endroit.',
      ctaMain: 'usfans spreadsheet',
      ctaBuy: 'acheter maintenant',
      ctaGuide: 'Lire le guide complet',
      trust: 'Ressource indépendante • Guides mis à jour • Multilingue • Axé sur la sécurité',
    },
    what: {
      title: 'Qu\'est-ce que le USFans Spreadsheet ?',
      p1: 'Le USFans Spreadsheet est un annuaire organisé par catégories d\'articles à thème américain. Il regroupe les types de produits les plus populaires — des chaussures et couvre-chefs aux accessoires et parfums — dans une structure simple et navigable pour que vous sachiez toujours où chercher.',
      p2: 'Au lieu d\'ouvrir des dizaines d\'onglets ou de deviner où se trouve un produit, vous pouvez accéder directement à la collection correspondante grâce à un lien clair et unique. Il est conçu pour réduire les frictions et aider les fans comme les acheteurs à trouver plus vite ce qu\'ils veulent.',
    },
    categories: {
      title: 'Parcourir les catégories populaires',
      subtitle: 'Choisissez une catégorie ci-dessous pour accéder directement à la collection correspondante sur notre site principal.',
      dropdownLabel: 'Sélectionnez une catégorie',
      dropdownPlaceholder: 'Choisissez une catégorie...',
      gridCta: 'Explorer',
    },
    why: {
      title: 'Pourquoi utiliser le USFans Spreadsheet ?',
      f1title: 'Organisation claire',
      f1text: 'Chaque type de produit est regroupé dans une catégorie simple et prévisible, sans désordre ni devinettes.',
      f2title: 'Accès rapide',
      f2text: 'Les liens directs vous mènent à la collection exacte en un clic, sans recherches ni filtres interminables.',
      f3title: 'Toujours à jour',
      f3text: 'La ressource est maintenue et mise à jour afin que les catégories et les guides restent utiles dans le temps.',
      f4title: 'Conçu pour les fans',
      f4text: 'Des maillots aux accessoires, la structure reflète ce que les fans et les acheteurs recherchent vraiment.',
    },
    guide: {
      title: 'Guide en vedette',
      cardTitle: 'USFans Spreadsheet : Le guide complet',
      cardDesc: 'Découvrez ce qu\'est le spreadsheet, ce que vous y trouverez, comment l\'utiliser et obtenez des conseils pratiques, ainsi qu\'un tableau comparatif pratique et une FAQ.',
      cardCta: 'Lire le guide',
      cardDate: 'Mis à jour régulièrement',
    },
    articles: {
      title: 'Guides et articles',
      subtitle: "Des guides détaillés sur le USFans spreadsheet, les avis, la livraison, les coupons, la sécurité et plus encore.",
      readMore: "Lire l'article",
    },
    faq: {
      title: 'Questions fréquentes',
      q1: 'Qu\'est-ce que le USFans Spreadsheet ?',
      a1: 'C\'est un annuaire par catégories qui organise les articles et vêtements de fans américains dans une structure simple et navigable avec des liens directs vers chaque collection.',
      q2: 'Comment utiliser les liens de catégorie ?',
      a2: 'Choisissez une catégorie dans le menu déroulant ou touchez n\'importe quelle carte de catégorie. Vous serez redirigé directement vers la collection correspondante sur le site principal.',
      q3: 'Est-ce le site officiel de USFans ?',
      a3: 'Non. C\'est une ressource informative indépendante qui renvoie vers le site principal, où les produits sont réellement vendus.',
      q4: 'Dois-je créer un compte pour parcourir ?',
      a4: 'Aucun compte n\'est requis. Vous pouvez parcourir toutes les catégories et lire tous les guides entièrement gratuitement.',
      q5: 'Comment accéder au site principal ?',
      a5: 'Utilisez les boutons "usfans spreadsheet" ou "acheter maintenant", ou n\'importe quel lien de catégorie : ils mènent tous au site principal.',
    },
    cta: {
      title: 'Prêt à explorer ?',
      text: 'Parcourez toutes les catégories ou rendez-vous directement sur le site principal pour voir la collection complète.',
      button: 'Visiter le site principal',
      button2: 'usfans spreadsheet',
    },
  },
};